export const MEDIA_START_TRACKING_GOAL = 'MEDIA_START_TRACKING_GOAL';

export const MEDIA_TRACKING_GOAL_SUCCESS = 'MEDIA_TRACKING_GOAL_SUCCESS';

export const MEDIA_TRACKING_GOAL_FAILED = 'MEDIA_TRACKING_GOAL_FAILED';